export const storeConfigs = {
    getPanelStatus: 'GET-PANEL-STATUS',
    getResult: 'GET-RESULT',
    activePanelStatus: 'ACTIVE-PANEL-STATUS',
    closePanel: 'DISABLE-PANEL-STATUS',
    calculate: 'CALCULATE0',
}